/*
* Association inventory detail view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Button, Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../common/formatters';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const InventoryDetailFormComponentDetailsLeft = ({
    appText,
    handleFormInputChange,
    handleFormInputChangeEvaluation,
    handleFormInputCustomEvaluation,
    handleFormInputChangeUsefulLife,
    handleFormInputCategoryFilter,
    handleCalculate,
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,
    handleNoteDelete,
    handleNoteSave,
    handleAddBestExplanation,
    handleAddWorstExplanation,
    handleAddEvaluation,
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidth = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        // handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    let inputPropsFullWidthEvaluationLevel = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChangeEvaluation(n, v); },
        className: 'edit-inventory-combo-evaluation-change',
    });

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
    });

    const inputPropsTextAreaDebounced = _.merge({}, defaultInputProps, {
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 12,
        colInputXs: 12,
    });

    let inputProps = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
    });

    let inputPropsUsefulLife = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChangeUsefulLife(n, v); },
    });

    let inputPropsReplacementCosts = _.merge({}, defaultInputProps, {
        onChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'edit-inventory-combo-replacement-costs'
    });

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
    });

    const renderComboItemEvaluationConditionLevel = (li: any, itemProps: any, fdOptionsFull: any = {}) => {
        const comboItemText = Formatters.getStr(itemProps, 'dataItem');

        let groupName = '';
        const comboItemOptFull = _.find(fdOptionsFull, ['evaluationName', comboItemText]);
        if (comboItemOptFull) { groupName = Formatters.getStr(comboItemOptFull, 'authUserGroupIds.description'); }

        const itemChildren = (
            <div className="edit-inventory-evaluation-description-combo-item-wrapper">
                <div className="edit-inventory-evaluation-description-combo-item-explanation">{li.props.children}</div>
                {/* <div className="edit-inventory-evaluation-description-combo-item-group">{groupName}</div> */}
            </div>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };

    const renderComboItemReplacementCostBest = (li: any, itemProps: any, fdOptionsFull: any = {}) => {
        const comboItemText = Formatters.getStr(itemProps, 'dataItem');

        let groupName = '';
        const comboItemOptFull = _.find(fdOptionsFull, ['explanation', comboItemText]);
        if (comboItemOptFull) { groupName = Formatters.getStr(comboItemOptFull, 'authUserGroup.description'); }

        const itemChildren = (
            <div className="edit-inventory-best-explanation-combo-item-wrapper">
                <div className="edit-inventory-best-explanation-combo-item-explanation">{li.props.children}</div>
                <div className="edit-inventory-best-explanation-combo-item-group">{groupName}</div>
            </div>
        );

        // Ensure unique key for the cloned element
        const uniqueKey = `combo-item-${comboItemText}-${itemProps.index || Math.random()}`;
        return React.cloneElement(li, { ...li.props, key: uniqueKey }, itemChildren);
    };

    const customCostSourceOptions = _.uniq(_.concat(formData.costSourceOptions, formData.costSource));
    const saveNewCustomEvaluationButton = (numFormChanges === 0) ? <Button bsSize="xs" bsStyle="info" onClick={e => { handleAddEvaluation(e); }}>
        <i className="fa fa-save" />
    </Button> : <div />;

    return (
        <DetailFormCommon.InventoryDetailFormSection title={sectionTitle}>
            <div>
                <Row xs={12}>
                    <Col xs={6}>
                        <div>
                            <KendoWrappers.KendoDisabledInputHidden
                                name="_component.inventoryId"
                                label={appText('inventory-id')}
                                value={formData.inventoryId}
                                {...inputProps}
                            />
                        </div>
                    </Col>
                    <Col xs={3}>
                        <div>
                            <KendoWrappers.KendoCheckbox
                                name="complete"
                                label={appText('complete')}
                                value={formData.complete}
                                {...inputProps}
                            />
                        </div>
                    </Col>
                    <Col xs={3}>
                        <div>
                            <KendoWrappers.KendoCheckbox
                                name="reviewed"
                                label={appText('reviewed')}
                                value={formData.reviewed}
                                {...inputProps}
                            />
                        </div>
                    </Col>
                </Row>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <Row xs={12} className="kendo-form-row">
                        <Col xs={6} className="kendo-form-input-col">
                            <KendoWrappers.KendoVirtualizedSelectInput
                                name="componentCategoryFilter"
                                clearable={true}
                                label={appText('component-categories')}
                                labelKey="label"
                                valueKey="value"
                                required={false}
                                value={formData.selectedComponentCategoryOption}
                                options={formData.componentCategoriesOptions}
                                optionRenderer={DetailFormCommon.NameOptionRenderer}
                                onChange={(o) => { handleFormInputCategoryFilter(o); }}
                                {...inputPropsVirtualizedSelect}
                            />
                        </Col>
                        <Col xs={6} className="kendo-form-input-col">
                            <KendoWrappers.KendoVirtualizedSelectInput
                                name="componentId"
                                clearable={false}
                                label={appText('component')}
                                labelKey="label"
                                valueKey="value"
                                required={true}
                                value={formData.selectedComponentOption}
                                options={formData.groupedComponentOptions}
                                optionRenderer={DetailFormCommon.NameOptionRenderer}
                                onChange={(o) => { handleFormInputChange({ target: { name: 'componentId', type: 'virtualized-select' } }, o); }}
                                {...inputPropsVirtualizedSelect}
                            />
                        </Col>
                    </Row>
                    <DetailFormCommon.InventoryDetailFormSectionSpacing />
                    <Row xs={12} className="kendo-form-row">
                        <Col xs={7}>
                            <KendoWrappers.KendoTextInputDebounced
                                name="componentCustomName"
                                label={appText('component-override-name')}
                                value={formData.componentCustomName}
                                disableWrapper={false}
                                {...inputPropsFullWidthTextDebounced}
                            />
                        </Col>
                        <Col xs={5} className="kendo-form-input-col">
                            <KendoWrappers.KendoTextInputDebounced
                                name="componentDecimal"
                                label={appText('component-decimal-number')}
                                value={formData.componentDecimal}
                                disableWrapper={false}
                                {...inputPropsFullWidthTextDebounced}
                            />
                        </Col>
                    </Row>
                </div>

                {/* grouped valued */}
                <DetailFormCommon.InventoryDetailFormSectionSpacing />
                <div>
                    <KendoWrappers.KendoComboInput
                        name="location"
                        label={appText('location')}
                        value={formData.location}
                        data={formData.locationOptions}
                        allowCustom={true}
                        {...inputPropsFullWidth}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="quantity"
                        label={appText('quantity')}
                        value={formData.quantity}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>
                <div>
                    <Row xs={12} className="kendo-form-ul-rul-row">
                        <Col xs={5}>
                            <div>
                                <KendoWrappers.KendoComboInput
                                    name="usefulLife"
                                    label={appText('useful-life')}
                                    value={formData.usefulLife}
                                    data={formData.usefulLifeOptions}
                                    allowCustom={true}
                                    {...inputPropsUsefulLife}
                                />
                            </div>
                        </Col>
                        <Col xs={5}>
                            <div>
                                <KendoWrappers.KendoNumberInput
                                    name="remainingUsefulLife"
                                    label={appText('remaining-useful-life')}
                                    value={formData.remainingUsefulLife}
                                    min={0}
                                    step={1}
                                    max={999}
                                    format="###"
                                    {...inputProps}
                                />
                            </div>
                        </Col>
                        <Col xs={2}>
                            <div/>
                        </Col>
                    </Row>
                </div>
                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoCurrencyInput
                        name="bestCost"
                        label={appText('best-cost')}
                        value={formData.bestCost}
                        {...inputProps}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoComboInputChildren
                        name="bestExplanation"
                        label={appText('best-cost-explanation')}
                        placeholder={appText('best-cost-explanation')}
                        value={formData.bestExplanation}
                        data={formData.bestExplanationOptions}
                        itemRender={(a: any, b: any) => renderComboItemReplacementCostBest(a, b, _.get(formData, 'bestExplanationOptionsFull', []))}
                        allowCustom={true}
                        clearable={true}
                        {...inputPropsReplacementCosts}
                    >
                        <div className="edit-inventory-add-explanation-button-wrapper">
                            <Button bsSize="xs" bsStyle="info" onClick={e => { handleAddBestExplanation(e); }}>
                                <i className="fa fa-pencil" />{ /*"fa fa-cog" /> */}
                            </Button>
                        </div>
                    </KendoWrappers.KendoComboInputChildren>
                </div>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoCurrencyInput
                        name="worstCost"
                        label={appText('worst-cost')}
                        value={formData.worstCost}
                        {...inputProps}
                    >
                        <div className="edit-inventory-calculate-button-wrapper">
                            <Button bsSize="xs" bsStyle="info" onClick={e => { handleCalculate(e); }}>
                                <i className="fa fa-calculator" /> {appText('buttons.calculate')}
                            </Button>
                        </div>
                    </KendoWrappers.KendoCurrencyInput>
                </div>

                <div>
                    <KendoWrappers.KendoComboInputChildren
                        name="worstExplanation"
                        label={appText('worst-cost-explanation')}
                        placeholder={appText('worst-cost-explanation')}
                        value={formData.worstExplanation}
                        data={formData.worstExplanationOptions}
                        itemRender={(a: any, b: any) => renderComboItemReplacementCostBest(a, b, _.get(formData, 'worstExplanationOptionsFull', []))}
                        allowCustom={true}
                        {...inputPropsReplacementCosts}
                    >
                        <div className="edit-inventory-add-explanation-button-wrapper">
                            <Button bsSize="xs" bsStyle="info" onClick={e => { handleAddWorstExplanation(e); }}>
                                <i className="fa fa-pencil" />{ /*"fa fa-cog" /> */}
                            </Button>
                        </div>
                    </KendoWrappers.KendoComboInputChildren>
                </div>

                <div>
                    <KendoWrappers.KendoDisabledInputHidden
                        name="avgCost"
                        label={appText('avg-cost')}
                        value={formData.avgCost}
                        {...inputProps}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoComboInput
                        name="costSource"
                        label={appText('source')}
                        value={formData.costSource}
                        data={customCostSourceOptions}
                        allowCustom={true}
                        {...inputPropsFullWidth}
                    />
                </div>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoComboInputChildren
                        name="evaluationConditionLevel"
                        label="Evaluation Dropdown"
                        placeholder={(formData.evaluation) ? _.get(formData, 'evaluation') : appText('condition-level-custom')}
                        value={formData.evaluationConditionLevel}
                        data={formData.evaluationConditionLevelOptions}
                        itemRender={(a: any, b: any) => renderComboItemEvaluationConditionLevel(a, b, _.get(formData, 'evaluationConditionLevelValues', []))}
                        allowCustom={true}
                        {...inputPropsFullWidthEvaluationLevel}
                    >
                        {/* TODO: Fix the evaluation modal to create new generic evaluations */}
                        <div className="edit-inventory-add-explanation-button-wrapper">
                            {saveNewCustomEvaluationButton}
                        </div>
                    </KendoWrappers.KendoComboInputChildren>
                </div>
                
                <div>
                    <KendoWrappers.KendoTextareaDebounced
                        name="evaluation"
                        label="Evaluation Text"
                        rows={4}
                        cols={40}
                        value={formData.evaluation}
                        onChange={handleFormInputCustomEvaluation}
                        {...inputPropsTextAreaDebounced}
                    />
                </div>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <DetailFormCommon.InventoryNoteRow key={`inventory-note-row-report-notes-add`}>
                        <DetailFormCommon.InventoryNote
                            authorText="Add New Report Note"
                            dateText=""
                            onClickDelete={(e) => { handleNoteDelete(e); }}
                            onClickSave={(e) => { handleNoteSave(e); }}
                            deleteButtonVisible={false}
                            saveButtonVisible={true}
                        >
                            <KendoWrappers.KendoTextareaDebounced
                                name="reportNotesAdd"
                                label=""
                                rows={4}
                                cols={40}
                                value={formData.reportNotesAdd}
                                {...inputPropsTextAreaDebounced}
                            />
                        </DetailFormCommon.InventoryNote>
                    </DetailFormCommon.InventoryNoteRow>

                    <DetailFormCommon.ReportNotes name="reportNotesDelete" reportNotes={formData.reportNotes} onClickDelete={handleNoteDelete} onClickSave={handleNoteSave} deleteButtonVisible={true} saveButtonVisible={false} />
                </div>

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoTextareaDebounced
                        name="clientQuestions"
                        label={appText('client-questions')}
                        rows={2}
                        cols={40}
                        value={formData.clientQuestions}
                        {...inputPropsTextAreaDebounced}
                    />
                </div>

                {/*<div>
                    <KendoWrappers.KendoCheckbox
                        name="printClientQuestions"
                        label={appText('print-client-questions')}
                        value={(formData.printClientQuestions || (formData.clientQuestions !== '') ? true : false) ? true : false}
                        // value={true}
                        disabled={true}
                        {...inputProps}
                    />
                </div>*/}

                <DetailFormCommon.InventoryDetailFormSectionSpacing />

                { /* <div>
                    <KendoWrappers.KendoCheckbox
                        name="printNote"
                        label={appText('print-note')}
                        value={formData.printNote}
                        {...inputProps}
                    />
                </div> */ }
            </div>
        </DetailFormCommon.InventoryDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/inventory/detail-form/component-details-left.tsx